import React, { Component } from 'react';
import Popup from '../../Popup';
import Img from '../../Img';

import styles from './boardmembers.module.scss';

const bgImg = (imageObj) => {
    if (imageObj && imageObj.oneX && imageObj.twoX && imageObj.threeX) {
        return (
            <Img
                useRawSrcSet={true}
                src={imageObj.oneX}
                srcSet={`${imageObj.twoX} 2x, ${imageObj.threeX} 3x`}
            />
        );
    } if (imageObj && imageObj.default) {
        return (
            <Img
                src={imageObj.default}
            />
        );
    }
    return null;
};

const BoardMember = (props) => {
    console.log('BoardMember data', props.data);
    const { data } = props;
    const nameArr = data && data.name ? data.name.split(' ') : [];

    return (
        <div
            className={styles.tile}
            onClick={props.onMemberClick}
        >
            <picture className={`${styles.img} d-none d-sm-block`}>
                {data && data.image && data.image.desktop && bgImg(data.image.desktop)}
            </picture>
            <picture className={`${styles.img} d-block d-sm-none`}>
                {data && data.image && data.image.mobile && bgImg(data.image.mobile)}
            </picture>
            <div className={`${styles.overlay} ${data.type === 'company' ? `${styles.dark} d-none d-sm-flex` : ''}`}>
                <div className={styles.div} />
                <div className={styles.name}>{nameArr[0]} {nameArr[1] ? <React.Fragment><br className={`d-block d-sm-none`} /><span className="text-bold">{nameArr[1]}</span></React.Fragment> : ''}</div>
            </div>
        </div>
    );
};

class BoardMembers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showPopup: false,
            popupMember: null,
        };

        this.onMemberClick = this.onMemberClick.bind(this);
        this.closePopup = this.closePopup.bind(this);
    }

    onMemberClick(member) {
        this.setState({
            showPopup: true,
            popupMember: member,
        });
    }

    closePopup() {
        this.setState({
            showPopup: false,
            popupMember: null,
        });
    }

    render() {
        // const members = [{ name: 'Name Name' }, { name: 'Name Name' }, { name: 'Name Name' }, { name: 'Name' }, { name: 'Name' }, { name: 'Name' }]
        const { title, members } = this.props;
        const nameArr = this.state.popupMember && this.state.popupMember.name ? this.state.popupMember.name.split(' ') : [];
        return (
            <div className={styles.section}>
                <div className={`container`}>
                    {title && (
                        <h3 className={styles.title}>{title}</h3>
                    )}
                    <div className={`row justify-content-center`}>
                        {members.map((member, i) => {
                            return (
                                <div className={`col-6 col-md-2`} key={`bm${i}`}>
                                    <BoardMember
                                        data={member}
                                        onMemberClick={() => this.onMemberClick(member)}
                                    />
                                </div>
                            );
                        })}
                    </div>
                </div>
                {this.state.showPopup && (
                    <Popup
                        className={`popup-sm`}
                        popUpClassName={`${styles.popup}`}
                        onCloseClick={this.closePopup}
                        config={{
                            fullScreen: false,
                            scrollable: true,
                            noPadding: true,
                            topGradient: false,
                            style: {
                                height: '400px',
                                width: '600px',
                            },
                        }}
                    >
                        <div className="popup-section p24 pt32 pb0 mb24">
                            <div className={`${styles.div}`} />
                            <div className={`${styles.name} pt16`}>{nameArr[0]} {nameArr[1] ? <span className="text-bold">{nameArr[1]}</span> : ''}</div>
                            <div className={`${styles.description} pt16 pb36`}>{this.state.popupMember.board_member_description || this.state.popupMember.investors_or_partner_description}</div>
                        </div>
                    </Popup>
                )}
            </div>
        );
    }
}

export default BoardMembers;
